import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AuthenticatedRouter from './authenticated_router';
import GuestJoin from '../components/guest/GuestJoin';

function AppRouter() {
  return (
    <Router>
      <Routes>
        <Route path="/guest-join" element={<GuestJoin />} />
        <Route path="*" element={<AuthenticatedRouter />} />
      </Routes>
    </Router>
  );
}

export default AppRouter;